import {
    ActionSpinOptions, ActionSpinSound,
    ASWinData, IResponseData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {Possessed} from "../Possessed";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {PossessedGameAssets} from '../PossessedGameAssets';
import {PossessedGameData} from '../server/PossessedData';

/**
 * Created by jonas on 2023-11-01.
 */

export class PossessedPromoPanelConfig implements PromoPanelGameConfiguration{

    constructor() {
    }

    //isLegalStopOnBonusMode(data: IResponseData): boolean {
    //    return data.nextMode != GameMode.RESPIN;
    //}


    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Possessed",
            hasActionSpin: true,
            mainGame: {
                header: ()=>"xBET",
                options: [
                    {name:"NORMAL", id:0, image:"NORMAL.png"},
                    {name:"BOOSTED_BET" ,id:1, image:"BOOSTED_BET.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: {backgroundTextureName: "introBg"},
            getParsedData: (response: PossessedGameData, bet: number, prevResponse: PossessedGameData):ASWinData => {
                return {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: (Possessed.model.triggeredFreespins()),//(response.mode == GameMode.NORMAL || response.mode) && response.nextMode != GameMode.NORMAL,
                    totalSpinWinnings: this.getWinSize(response), //response.totalSpinWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response), //response.nextMode == GameMode.NORMAL,
                    isBonusEnd: response.mode != GameMode.NORMAL && response.nextMode == GameMode.NORMAL,
                    isWinCapHit: response.brokeTheBank,
                }
            }
        };
    }

    private getWinSize(response:PossessedGameData) {
        return response.mode != GameMode.NORMAL && response.nextMode == GameMode.NORMAL
               ? response.betWayWins.map((win) => win.multipliedAmount).reduce((a,b) => a+b, 0)
               : response.totalSpinWinnings;
    }

    private getFeatureName(response: PossessedGameData): string {
        if(response.freeSpinType != 0) {
            switch (response.freeSpinType) {
                case 3: return "NECROMANCY SPINS";
                case 4: return "ATONEMENT SPINS";
                case 5: return "BEELZEBUB SPINS";
                default: return response.mode;
            }
        } else if(response.nextMode == GameMode.RESPIN) {
            return "RESPIN";
        } else {
            return response.mode;
        }
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN)
            Possessed.soundPlayer.playSound("asWin");
        else if (trigger == ActionSpinSound.BIG_WIN)
            Possessed.soundPlayer.playSound("asWinBig");
    }

    private isBigWin(response:PossessedGameData): boolean {
        let win = response.totalSpinWinnings;

        if (response.wasFeatureBuy){
            const betPrice = Possessed.getBetPrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private isRoundComplete(response: PossessedGameData): boolean {
        return ([GameMode.FREESPIN,GameMode.FREESPIN_SUPER, GameMode.NORMAL].indexOf(response.nextMode) > -1);
    }
}